import { render, staticRenderFns } from "./OrderBy.vue?vue&type=template&id=d90e56ba&"
import script from "./OrderBy.vue?vue&type=script&lang=js&"
export * from "./OrderBy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports